import { Injectable } from '@angular/core';
import { QuantiteAndPourcentageDTO } from '../model/quantite-and-pourcentage-dto';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { QuantiteDossierPortefeuilleJuridiqueParProduitDTO } from '../model/quantite-dossier-portefeuille-juridique-par-produit-dto';
import { QuantiteDossierPortefeuilleJuridiqueParProfileDTO } from '../model/quantite-dossier-portefeuille-juridique-par-profile-dto';
import { SlaProduitDTO } from '../model/sla-produit-dto';
import { DurationByProduitDTO } from '../model/duration-by-produit-dto';
import { DurationByTaskDTO } from '../model/duration-by-task-dto';
import { ProductiviteByProfileDTO } from '../model/productivite-by-profile-dto';
import { QuantiteDossierByEmployeeDTO } from '../model/quantite-dossier-by-employee-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { DashboardDossierCredit } from '../model/DashboardDossierCredit';
import { PageDashboardDossierCredit } from '../model/PageDashboardDossierCredit';

@Injectable({
    providedIn: 'root'
  })
export class DashboardDirectionJuridiqueService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    quantiteDossierPortefeuille() 
    {
        return this._restClientService.load<QuantiteAndPourcentageDTO[]>('dashboard-direction-juridique/quantite-dossier-portefeuille');
    }
    
    quantiteDossierPortefeuille12DerniersMois() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/quantite-dossier-portefeuille-12-derniers-mois');
    }
    
    quantiteDossierTraiteEtEncourssur12DerniersMois() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/quantite-dossier-traite-et-encours-12-derniers-mois');
    }
    
    quantiteDossierPortefeuilleParProduit() 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleJuridiqueParProduitDTO[]>('dashboard-direction-juridique/quantite-dossier-portefeuille-par-produit');
    }
    
    quantiteDossierPortefeuilleParProfile() 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleJuridiqueParProfileDTO[]>('dashboard-direction-juridique/quantite-dossier-portefeuille-par-profile');
    }
    
    slaTacheParProduit() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/sla-tache-par-produit');
    }

    slaPeriodeParProduit() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/sla-periode-par-produit');
    }
    
    slaPeriodeParProfile() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/sla-periode-par-profile');
    }
    
    slaProduit() 
    {
        return this._restClientService.load<SlaProduitDTO[]>('dashboard-direction-juridique/sla-produit');
    }
    
    durationProduit() 
    {
        return this._restClientService.load<DurationByProduitDTO[]>('dashboard-direction-juridique/duration-produit');
    }
    
    durationTask(codeProduit) 
    {
        return this._restClientService.load<DurationByTaskDTO[]>('dashboard-direction-juridique/duration-task?codeProduit='+codeProduit);
    }
    
    dossierPeriodeParProfile() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/dossier-periode-par-profile');
    }
    
    productiviteByProfile() 
    {
        return this._restClientService.load<ProductiviteByProfileDTO[]>('dashboard-direction-juridique/productivite-by-profile');
    }
    
    quantiteDossierByEmployee() 
    {
        return this._restClientService.load<QuantiteDossierByEmployeeDTO[]>('dashboard-direction-juridique/quantite-dossier-by-employee');
    }

    /********* CREDIT CARD VIEW **************/
    getDossiersJuridiqueStatus(filter: string, pageIndex: number, pageSize: number): any {
        return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-direction-juridique/dossiers-juridique-status?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
      }
    getDossiersCreditJuridiqueEnCours(filter: string, pageIndex: number, pageSize: number): any {
        return this._restClientService.load<DashboardDossierCredit[]>(`dashboard-direction-juridique/dossiers-juridique-en-cours?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
      }
  
      getDossiersCreditJuridiqueEnRetard(filter: string, pageIndex: number, pageSize: number): any {
        return this._restClientService.load<DashboardDossierCredit[]>(`dashboard-direction-juridique/dossiers-juridique-en-retard?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
      }
  
      getDossiersCreditJuridiqueMiseEnPlace(filter: string, pageIndex: number, pageSize: number): any {
        return this._restClientService.load<DashboardDossierCredit[]>(`dashboard-direction-juridique/dossiers-juridique-mise-en-place?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
      }
      
      getDossiersCreditJuridiqueEnCorrection(filter: string, pageIndex: number, pageSize: number): any {
        return this._restClientService.load<DashboardDossierCredit[]>(`dashboard-direction-juridique/dossiers-juridique-en-correction?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
      }
    
}